module.exports = __webpack_public_path__ + "static/img/l_1_2.79a3173.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build922/assets/image/My/l_1_2.png
// module id = o8If
// module chunks = 0 1 2 3 4 5 6